<!--底部导航条-->
<template>
  <footer class="footer-component">
    <div class="version-center">
      <p>
        <span
          @click="
            onlinkRouter('/institutional-overview', {
              title: '机构概况',
              tag: '中心概况'
            })
          "
          class="hover-inter-active"
          >关于我们
        </span>
        <span class="i">|</span>
        <span
          class="hover-inter-active"
          @click="
            onlinkRouter('/office-hall', { title: '公众服务', ...listarr[1] })
          "
        >
          公正性声明
        </span>
        <span class="i">|</span>
        <span
          class="hover-inter-active"
          @click="
            onlinkRouter('/office-hall', { title: '公众服务', ...listarr[2] })
          "
          >诚信检验检测承诺书</span
        >
        <span class="i">|</span>
        <span
          class="hover-inter-active"
          @click="
            onlinkRouter('/institutional-overview', {
              title: '机构概况',
              tag: '联系方式',
              hash: 'tab4',
              to: 400
            })
          "
        >
          联系方式
        </span>
      </p>

      <p>地址 : 南宁市江南区国凯大道东19号金凯工业园13号楼</p>
      <p>邮编 : 530031</p>
      <p>电话 : 0771-2898046</p>
      <p>邮箱 : qjzxbgs@yjj.gxzf.gov.cn</p>
      <el-divider></el-divider>
      <p style="margin-bottom: 12px; line-height: 1.5">
        Copyright &copy;
        {{ new Date().getFullYear() }} 广西壮族自治区医疗器械检测中心
        版权所有&emsp;
        <a
          class="link"
          href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
          target="_blank"
          style="margin-bottom: 0"
        >
          桂ICP备18007800号
        </a>
      </p>
      <p class="iconcomp">
        <img src="../assets/images/footer-1.png" alt="" />&ensp;桂公网安备
        45010302002029 号
      </p>
    </div>
    <!-- 回到顶部 -->
    <el-backtop :bottom="100" :right="24" class="backtop">
      <i class="el-icon-arrow-up"></i>
    </el-backtop>
  </footer>
</template>
<script>
import { mapState } from 'vuex'
export default {
  components: {},
  data() {
    return { listarr: [] }
  },
  computed: {
    ...mapState(['menuArr'])
  },
  methods: {
    onlinkRouter(path, { hash, key, tag, to, title }) {
      if (path == '/office-hall') {
        this.$store.commit('SET_TABS', {
          ...path,
          children: this.menuArr[4].children
        })
      }
      if (window.innerWidth < 768) {
        this.$router.push({
          path,
          query: { tag, title, key },
          hash
        })
      } else {
        this.$router.push({
          path,
          query: { tag, title, key }
        })
        if (to) {
          setTimeout(function () {
            window.scrollTo(0, to)
          }, 200)
        }
      }
    }
  },
  created() {
    this.listarr = this.menuArr.find(
      (item) => item.title == '公众服务'
    ).children
  }
}
</script>
<style lang="scss" scoped>
.footer-component {
  position: relative;
  width: 100%;
  background: url(../assets/images/footer.webp) no-repeat;
  background-size: 100% 100%;
  object-fit: fill;
  height: 270px;

  .version-center {
    padding: 28px 0 24px;
    * {
      color: #fff;
      text-align: center;
      margin-bottom: 14px;
    }
    .el-divider--horizontal {
      margin: 0 0 12px;
    }
    p {
      display: flex;
      justify-content: center;
      line-height: 1;
    }
    span {
      margin: 0 12px;
      cursor: pointer;
    }
  }

  // 回到顶部
  .backtop {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    background: rgb(245 245 245);
    .el-icon-arrow-up:before {
      color: #14579e;
      font-size: 30px;
      font-weight: 800;
    }
  }
}
@media screen and (max-width: 768px) {
  .footer-component {
    height: 440px;
    .version-center {
      width: 100%;
      padding: 16px 16px 24px;
      * {
        color: #fff;
        text-align: center;
        margin-bottom: 14px;
      }
      .el-divider--horizontal {
        margin: 0 0 12px;
      }
      p {
        display: flex;
        justify-content: center;
        flex-direction: column;
        line-height: 1.2;
      }
      span {
        margin: 6px 12px;
        display: block;
      }
      .i {
        display: none;
      }
      img {
        width: 16px;
        height: 16px;
      }
      .iconcomp {
        flex-direction: row;
      }
    }
  }
}
</style>
